/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters */
import { LocalDate } from '@js-joda/core';

const CHOSEN_COUNTRY_LANG = 'chosenCountryLang';

export const setObject = (key: string, value: unknown) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const getObject = <T>(key: string): T | null => {
  const value = window.localStorage.getItem(key);

  return value ? (JSON.parse(value) as T) : null;
};

export const removeObject = (key: string) => {
  window.localStorage.removeItem(key);
};

export const setSessionObject = <T>(key: string, value: T): void => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionObject = <T>(key: string): T | null => {
  const value = window.sessionStorage.getItem(key);

  return value ? (JSON.parse(value) as T) : null;
};

export const removeSessionObject = (key: string) => {
  window.sessionStorage.removeItem(key);
};

export const clearSession = () => {
  window.sessionStorage.clear();
};

export const updateChosenLang = (language: string) => {
  const current = getObject<{ language: string }>(CHOSEN_COUNTRY_LANG) ?? {
    language: '',
  };

  current.language = language;

  setObject(CHOSEN_COUNTRY_LANG, current);
};

export const getCookie = <T>(key: string): T | null => {
  const nameEQ = `${key}=`;
  const ca = window.document.cookie.split(';');

  for (const element of ca) {
    let c = element;

    while (c.startsWith(' ')) {
      c = c.substring(1, c.length);
    }

    if (c.startsWith(nameEQ)) {
      const value = c.substring(nameEQ.length, c.length);

      try {
        return JSON.parse(value) as T;
      } catch {
        return null;
      }
    }
  }

  return null;
};

export const setCookie = <T>(key: string, value: T, time: number): void => {
  let expires = '';

  if (time) {
    // Create a date from a unix timestamp (86400 = seconds in a day)
    const date = LocalDate.ofEpochDay(time / 86400);

    expires = `; expires=${date.toString()}`;
  }

  const jsonValue = JSON.stringify(value);

  window.document.cookie = `${key}=${jsonValue || ''}${expires}; path=/`;
};

export const clearCookie = (key: string): void => {
  window.document.cookie = `${key}=; Max-Age=-99999999;`;
};
